/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineBookingPersonEmailDto } from './traveline-booking-person-email-dto';
import {
    TravelineBookingPersonEmailDtoFromJSON,
    TravelineBookingPersonEmailDtoFromJSONTyped,
    TravelineBookingPersonEmailDtoToJSON,
    TravelineBookingPersonEmailDtoToJSONTyped,
} from './traveline-booking-person-email-dto';
import type { TravelineBookingPersonPhoneDto } from './traveline-booking-person-phone-dto';
import {
    TravelineBookingPersonPhoneDtoFromJSON,
    TravelineBookingPersonPhoneDtoFromJSONTyped,
    TravelineBookingPersonPhoneDtoToJSON,
    TravelineBookingPersonPhoneDtoToJSONTyped,
} from './traveline-booking-person-phone-dto';

/**
 * Contact details entity
 * @export
 * @interface TravelineBookingPersonContactsDto
 */
export interface TravelineBookingPersonContactsDto {
    /**
     * Phone entity
     * @type {Array<TravelineBookingPersonPhoneDto>}
     * @memberof TravelineBookingPersonContactsDto
     */
    phones: Array<TravelineBookingPersonPhoneDto>;
    /**
     * Email entity
     * @type {Array<TravelineBookingPersonEmailDto>}
     * @memberof TravelineBookingPersonContactsDto
     */
    emails: Array<TravelineBookingPersonEmailDto>;
}

/**
 * Check if a given object implements the TravelineBookingPersonContactsDto interface.
 */
export function instanceOfTravelineBookingPersonContactsDto(value: object): value is TravelineBookingPersonContactsDto {
    if (!('phones' in value) || value['phones'] === undefined) return false;
    if (!('emails' in value) || value['emails'] === undefined) return false;
    return true;
}

export function TravelineBookingPersonContactsDtoFromJSON(json: any): TravelineBookingPersonContactsDto {
    return TravelineBookingPersonContactsDtoFromJSONTyped(json, false);
}

export function TravelineBookingPersonContactsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineBookingPersonContactsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'phones': ((json['phones'] as Array<any>).map(TravelineBookingPersonPhoneDtoFromJSON)),
        'emails': ((json['emails'] as Array<any>).map(TravelineBookingPersonEmailDtoFromJSON)),
    };
}

  export function TravelineBookingPersonContactsDtoToJSON(json: any): TravelineBookingPersonContactsDto {
      return TravelineBookingPersonContactsDtoToJSONTyped(json, false);
  }

  export function TravelineBookingPersonContactsDtoToJSONTyped(value?: TravelineBookingPersonContactsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'phones': ((value['phones'] as Array<any>).map(TravelineBookingPersonPhoneDtoToJSON)),
        'emails': ((value['emails'] as Array<any>).map(TravelineBookingPersonEmailDtoToJSON)),
    };
}

